import styled from 'styled-components';

export const GoogleSignInButton = styled.div.attrs({ id: 'google-sign-in' })`
  margin-top: 8px;
`;

export default {};
